/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SlackChannel
 */
export interface SlackChannel {
    /**
     * 
     * @type {string}
     * @memberof SlackChannel
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SlackChannel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SlackChannel
     */
    isPrivate: string;
}

export function SlackChannelFromJSON(json: any): SlackChannel {
    return SlackChannelFromJSONTyped(json, false);
}

export function SlackChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SlackChannel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'isPrivate': json['is_private'],
    };
}

export function SlackChannelToJSON(value?: SlackChannel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'is_private': value.isPrivate,
    };
}


